import component from './Maintenance.vue'
export default component
